[<RequireQualifiedAccess>]
module Shared.Urls

type NoArgs = Printf.StringFormat<string>
type Arg1 = Printf.StringFormat<string -> string>
type Arg2 = Printf.StringFormat<string -> string -> string>

[<Literal>]
let GetPage = "/api/page"

[<Literal>]
let GetPreview = "/api/preview"

[<Literal>]
let Login = "/api/login"

[<Literal>]
let GetPageHierarchy = "/api/menu"

let fmtPages: Arg1 = "/api/tenant/%s/pages"

let Pages tenant = sprintf fmtPages tenant

let fmtPageExistsById : Arg2 = "/api/tenant/%s/pages/id/%s/exists"

let PageExistsById tenant id = sprintf fmtPageExistsById tenant id

let fmtPageById : Arg2 = "/api/tenant/%s/pages/id/%s"
let PageById tenant id = sprintf fmtPageById tenant id

let fmtCategories: Arg1 = "/api/tenant/%s/categories"
let Categories tenant = sprintf fmtCategories tenant

let fmtCategoriesById : Arg2 = "/api/tenant/%s/categories/id/%s"
let CategoryById tenant id = sprintf fmtCategoriesById tenant id

let fmtUsers: Arg1 = "/api/tenant/%s/users"
let Users tenant = sprintf fmtUsers tenant

let fmtUsersByName : Arg2 = "/api/tenant/%s/users/%s"
let UserByName tenant name = sprintf fmtUsersByName tenant name

let fmtUserEmailByName : Arg2 = "/api/tenant/%s/email/%s"
let UserEmail tenant name = sprintf fmtUserEmailByName tenant name

[<Literal>]
let RequestResetEmail = "/api/resetEmail"

let fmtPasswordReset : Arg1 =  "/api/resetEmail/%s"
let PerformResetPassword (id:System.Guid) = sprintf fmtPasswordReset (id.ToString())

let fmtFiles: Arg1 = "/api/tenant/%s/uploads"
let Files tenant = sprintf fmtFiles tenant

let fmtImages: Arg1 = "/api/tenant/%s/images"
let Images tenant = sprintf fmtImages tenant

let fmtGetFile: Arg1 = "/api/tenant/%s/getFile"
let GetFile tenant filename = (sprintf fmtGetFile tenant) + "?f=" + filename

let fmtReferral : Arg1 = "/api/tenant/%s/referral"
let Referral tenant = sprintf fmtReferral tenant

let fmtTenants : NoArgs = "/api/tenants"
let Tenants = sprintf fmtTenants 

let fmtTenantName : Arg1 = "/api/tenant/%s/name"
let TenantName tenant = sprintf fmtTenantName tenant

let fmtConfirmReferral : Arg1 = "/api/tenant/%s/confirmReferral" 
let ConfirmReferral tenant = sprintf fmtConfirmReferral tenant

let fmtHelpPacks : Arg1 = "/api/tenant/%s/helppacks" 
let HelpPacks tenant = sprintf fmtHelpPacks tenant

let fmtAlcoholText : Arg1 = "/api/tenant/%s/alcohol" 
let AlcoholText tenant = sprintf fmtAlcoholText tenant

let fmtLoginEndpoint: Arg2 = "/api/tenant/%s/start-training/%s"
let LoginEndpoint tenant code = sprintf fmtLoginEndpoint tenant code
